import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/lastudioicons.css';
import './assets/css/vendor/dliconoutline.css';

// plugins
import './assets/css/animate.min.css';
import './assets/css/swiper-bundle.min.css';
import './assets/css/ion.rangeSlider.min.css';
import './assets/css/lightgallery-bundle.min.css';
import './assets/css/magnific-popup.css';

// other styles
import './assets/css/style.css';

// mui
import { ThemeProvider, createTheme } from '@mui/material/styles';

// scroll bar
import 'react-perfect-scrollbar/dist/css/styles.css';

import { Provider } from 'react-redux';
import { persistor, store } from './store/reducers';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppHelmet from './AppHelmet';

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppHelmet>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme}>
            <App />
            <ToastContainer toastClassName='toast-style' />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </AppHelmet>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
